import React from 'react';

import { Check } from '@mui/icons-material';
import { Box } from '@mui/material';
import themeColors from 'src/theme/colors';

export default function FinishedCheckMark() {
  return (
    <Box
      position="absolute"
      top="-6px"
      right="8px"
      fontSize="48px"
      color={themeColors.greenHover}
    >
      <Check fontSize="large" />
    </Box>
  );
}
